module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataReady) ? _c('div', {
    staticClass: "tab-content-contrat noselect"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "app"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.enregistrer($event)
      }
    }
  }, [_c('div', {
    staticClass: "body-tab"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-9 left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "nature-du-contrat-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeNatureContrat),
      expression: "salarieCourant.CodeNatureContrat"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.canModify,
      "placeholder": " ",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeNatureContrat", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.modifyPropertiesPrincipales()
      }]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeNatureContrats), function(natureContrat) {
    return _c('option', {
      domProps: {
        "value": natureContrat.Code
      }
    }, [_vm._v("\n                                                                        " + _vm._s(natureContrat.Code + '/' + natureContrat.Libelle) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Nature du contrat")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "type-de-contrat-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeTypeContrat),
      expression: "salarieCourant.CodeTypeContrat"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.canModify,
      "placeholder": " ",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeTypeContrat", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.modifyTypeDeContrat()
      }]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeTypeContrats), function(typeContrat) {
    return (typeContrat.EstVisiblePst) ? _c('option', {
      domProps: {
        "value": typeContrat.Code
      }
    }, [_vm._v("\n                                                                        " + _vm._s(typeContrat.Code + '/' + typeContrat.Libelle) + "\n                                                                    ")]) : _vm._e()
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Type de contrat")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "remuneration-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeRemuneration),
      expression: "salarieCourant.CodeRemuneration"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.canModify,
      "placeholder": " ",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeRemuneration", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.modifyPropertiesPrincipales()
      }]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeRemunerations), function(remuneration) {
    return _c('option', {
      domProps: {
        "value": remuneration.Code
      }
    }, [_vm._v("\n                                                                        " + _vm._s(remuneration.Code + '/' + remuneration.Libelle) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Rémunération")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), (_vm.salarieCourant.CodeTypeContrat == 'APP' || _vm.salarieCourant.CodeTypeContrat == 'PROFS') ? _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "niveau-de-diplome-suivi-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeDiplomePrepare),
      expression: "salarieCourant.CodeDiplomePrepare"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.canModify,
      "placeholder": " ",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeDiplomePrepare", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.modifyPropertiesPrincipales()
      }]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeDiplomesPrepares), function(diplomePrepare) {
    return _c('option', {
      domProps: {
        "value": diplomePrepare.Code
      }
    }, [_vm._v("\n                                                                        " + _vm._s(diplomePrepare.Code + '/' + diplomePrepare.Libelle) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Niveau de diplôme suivi")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input icon contrat-salarie-regime-select",
    attrs: {
      "data-testid": "maladie-retraite-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeMaladieRetraite),
      expression: "salarieCourant.CodeMaladieRetraite"
    }],
    staticClass: "input",
    attrs: {
      "data-testid": "maladie-retraite-select",
      "required": "",
      "placeholder": " ",
      "disabled": !_vm.canModify
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeMaladieRetraite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onRegimeChanged],
      "mousedown": _vm.onRegimeMouseDown
    }
  }, [_c('option', {
    staticClass: "option-aide-regime",
    domProps: {
      "value": _vm.regimeAideChoixKey
    }
  }, [_vm._v("ⓘ M'aider à choisir")]), _vm._v(" "), _vm._l((_vm.listeMaladieRetraitesFiltree), function(maladieRetraite) {
    return _c('option', {
      attrs: {
        "title": maladieRetraite.Code + '/' + maladieRetraite.Libelle + (maladieRetraite.EstArchive ? ' (obsolète)' : '')
      },
      domProps: {
        "value": maladieRetraite.Code
      }
    }, [_vm._v("\n                                                                        " + _vm._s(maladieRetraite.Code + '/' + maladieRetraite.Libelle + (maladieRetraite.EstArchive ? ' (obsolète)' : '')) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Maladie/retraite")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "c-transport-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeTransport),
      expression: "salarieCourant.CodeTransport"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": " ",
      "disabled": !_vm.canModify
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeTransport", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modifyForRubriques]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeTransports), function(transports) {
    return _c('option', {
      domProps: {
        "value": transports.Code
      }
    }, [_vm._v("\n                                                                        " + _vm._s(transports.Code + '/' + transports.Libelle) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("C. Transport")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "caisse-complementaire-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeCaisseComplementaire),
      expression: "salarieCourant.CodeCaisseComplementaire"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": " ",
      "data-testid": "caisse-complementaire-select",
      "disabled": !_vm.canModify
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeCaisseComplementaire", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.modifyCaisseComplementaire(_vm.salarieCourant.CodeCaisseComplementaire)
      }]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeCaisseComplementaires), function(caisseComplementaires) {
    return _c('option', {
      domProps: {
        "value": caisseComplementaires.Code
      }
    }, [_vm._v("\n                                                                        " + _vm._s(caisseComplementaires.Code + '/' + caisseComplementaires.Libelle) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Caisse complémentaire")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "autre-caisse-complementaire-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeAutreCaisse),
      expression: "salarieCourant.CodeAutreCaisse"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": " ",
      "disabled": !_vm.canModify
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeAutreCaisse", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.modifyCaisseComplementaire(_vm.salarieCourant.CodeAutreCaisse)
      }]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeCaisseComplementaires), function(caisseComplementaires) {
    return _c('option', {
      domProps: {
        "value": caisseComplementaires.Code
      }
    }, [_vm._v("\n                                                                        " + _vm._s(caisseComplementaires.Code + '/' + caisseComplementaires.Libelle) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Autre caisse complémentaire")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6",
    attrs: {
      "data-testid": "conges-field"
    }
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeGestionConge),
      expression: "salarieCourant.CodeGestionConge"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": " ",
      "disabled": !_vm.canModify
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeGestionConge", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modifyForRubriques]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeGestionConges), function(gestionConge) {
    return _c('option', {
      domProps: {
        "value": gestionConge.Code
      }
    }, [_vm._v("\n                                                                        " + _vm._s(gestionConge.Code + '/' + gestionConge.Libelle) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Congés")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input",
    attrs: {
      "data-testid": "jours-de-RTT-an-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.NbrRttAn),
      expression: "salarieCourant.NbrRttAn"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": " ",
      "min": "0",
      "max": "100",
      "step": "0.1",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.salarieCourant.NbrRttAn)
    },
    on: {
      "change": _vm.modifyForRubriques,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "NbrRttAn", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Jours de RTT/an")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "data-testid": "statut-travailleur-handicape-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeHandicape),
      expression: "salarieCourant.CodeHandicape"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": " ",
      "disabled": !_vm.canModify
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeHandicape", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modify]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeHandicapes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.Code
      }
    }, [_vm._v("\n                                                                        " + _vm._s(item.Code + '/' + item.Libelle) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Statut travailleur handicapé")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), (_vm.isModDemarrage) ? _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input",
    attrs: {
      "title": _vm.salarieCourant.NumeroContrat
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.NumeroContrat),
      expression: "salarieCourant.NumeroContrat"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": " ",
      "inputmode": "numeric",
      "pattern": "[0-9]*",
      "maxlength": "20",
      "required": "",
      "disabled": !_vm.canModify
    },
    domProps: {
      "value": (_vm.salarieCourant.NumeroContrat)
    },
    on: {
      "change": _vm.modify,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salarieCourant, "NumeroContrat", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("N° contrat")])])]) : _vm._e()]), _vm._v(" "), (_vm.salarieCourant.CodeNatureContrat == 'CDD' && _vm.salarieCourant.CodeTypeContrat != 'APP') ? _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input icon",
    attrs: {
      "title": _vm.getTitleMotifRecours(),
      "data-testid": "motif-du-recours-field"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeMotifRecours),
      expression: "salarieCourant.CodeMotifRecours"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": " ",
      "required": "",
      "disabled": !_vm.canModify
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeMotifRecours", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modify]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeMotifRecoursFiltered), function(item) {
    return _c('option', {
      domProps: {
        "value": item.Code
      }
    }, [_vm._v("\n                                                                        " + _vm._s(item.Code + '/' + item.Libelle) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Motif du recours")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), (_vm.salarieCourant.CodeMotifRecours == 'REMP') ? _c('div', {
    staticClass: "col-6"
  }, [_c('input-select', {
    attrs: {
      "label": "Salarié(e) remplacé(e)",
      "code": "Id",
      "display": "FullName",
      "list": _vm.listeSalarieEnCours,
      "required": true,
      "first": false,
      "vmodel": _vm.salarieCourant.IdSalarieRemplace
    },
    on: {
      "update:vmodel": function($event) {
        _vm.$set(_vm.salarieCourant, "IdSalarieRemplace", $event)
      },
      "change": function($event) {
        _vm.modify()
      }
    }
  })], 1) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "th cln-checkbox"
  }, [_c('div', {
    staticClass: "inp-checkbox d-flex",
    attrs: {
      "data-testid": "13ème-mois-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.TreiziemeMois),
      expression: "salarieCourant.TreiziemeMois"
    }],
    attrs: {
      "type": "checkbox",
      "id": "TreiziemeMois",
      "disabled": !_vm.canModify
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.TreiziemeMois) ? _vm._i(_vm.salarieCourant.TreiziemeMois, null) > -1 : (_vm.salarieCourant.TreiziemeMois)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.TreiziemeMois,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "TreiziemeMois", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "TreiziemeMois", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "TreiziemeMois", $$c)
        }
      }, _vm.modifyTreiziemeMois]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "TreiziemeMois"
    }
  }, [_vm._v("\n                                                                        13ème\n                                                                        mois\n                                                                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "th cln-checkbox"
  }, [_c('div', {
    staticClass: "inp-checkbox d-flex",
    attrs: {
      "data-testid": "13ème-mois-mensuel-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.EstTreiziemeMoisMensualise),
      expression: "salarieCourant.EstTreiziemeMoisMensualise"
    }],
    attrs: {
      "type": "checkbox",
      "id": "EstTreiziemeMoisMensualise",
      "disabled": !_vm.canModify || !_vm.salarieCourant.TreiziemeMois
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.EstTreiziemeMoisMensualise) ? _vm._i(_vm.salarieCourant.EstTreiziemeMoisMensualise, null) > -1 : (_vm.salarieCourant.EstTreiziemeMoisMensualise)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.EstTreiziemeMoisMensualise,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "EstTreiziemeMoisMensualise", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "EstTreiziemeMoisMensualise", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "EstTreiziemeMoisMensualise", $$c)
        }
      }, _vm.modifyForRubriques]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "EstTreiziemeMoisMensualise"
    }
  }, [_vm._v("\n                                                                        13ème mois mensuel\n                                                                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "th cln-checkbox"
  }, [_c('div', {
    staticClass: "inp-checkbox d-flex",
    attrs: {
      "data-testid": "salaire-perso-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.SalairePerso),
      expression: "salarieCourant.SalairePerso"
    }],
    attrs: {
      "type": "checkbox",
      "id": "SalairePerso",
      "disabled": !_vm.canModify
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.SalairePerso) ? _vm._i(_vm.salarieCourant.SalairePerso, null) > -1 : (_vm.salarieCourant.SalairePerso)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.SalairePerso,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "SalairePerso", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "SalairePerso", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "SalairePerso", $$c)
        }
      }, _vm.modifyForRubriques]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "SalairePerso"
    }
  }, [_vm._v("\n                                                                        SALAIRE\n                                                                        PERSO.\n                                                                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "th cln-checkbox"
  }, [_c('div', {
    staticClass: "inp-checkbox d-flex",
    attrs: {
      "data-testid": "notaire-salarie-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.EstNotaireSalarie),
      expression: "salarieCourant.EstNotaireSalarie"
    }],
    attrs: {
      "type": "checkbox",
      "id": "EstNotaireSalarie",
      "disabled": !_vm.canModify
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.EstNotaireSalarie) ? _vm._i(_vm.salarieCourant.EstNotaireSalarie, null) > -1 : (_vm.salarieCourant.EstNotaireSalarie)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.EstNotaireSalarie,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "EstNotaireSalarie", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "EstNotaireSalarie", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "EstNotaireSalarie", $$c)
        }
      }, _vm.modifyForRubriques]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "EstNotaireSalarie"
    }
  }, [_vm._v("\n                                                                        Notaire\n                                                                        Salarié\n                                                                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "th cln-checkbox"
  }, [_c('div', {
    staticClass: "inp-checkbox d-flex",
    attrs: {
      "data-testid": "titres-restaurant-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.TicketsRestaurant),
      expression: "salarieCourant.TicketsRestaurant"
    }],
    attrs: {
      "type": "checkbox",
      "id": "TicketsRestaurant",
      "disabled": !_vm.canModify
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.TicketsRestaurant) ? _vm._i(_vm.salarieCourant.TicketsRestaurant, null) > -1 : (_vm.salarieCourant.TicketsRestaurant)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.TicketsRestaurant,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "TicketsRestaurant", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "TicketsRestaurant", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "TicketsRestaurant", $$c)
        }
      }, _vm.modifyForRubriques]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "TicketsRestaurant"
    }
  }, [_vm._v("\n                                                                        Titres\n                                                                        restaurant\n                                                                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "th cln-checkbox"
  }, [_c('div', {
    staticClass: "inp-checkbox d-flex",
    attrs: {
      "data-testid": "frais-professionnels-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.FraisProfessionnels),
      expression: "salarieCourant.FraisProfessionnels"
    }],
    attrs: {
      "type": "checkbox",
      "id": "FraisProfessionnels",
      "disabled": !_vm.canModify
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.FraisProfessionnels) ? _vm._i(_vm.salarieCourant.FraisProfessionnels, null) > -1 : (_vm.salarieCourant.FraisProfessionnels)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.FraisProfessionnels,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "FraisProfessionnels", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "FraisProfessionnels", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "FraisProfessionnels", $$c)
        }
      }, _vm.modifyForRubriques]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "FraisProfessionnels"
    }
  }, [_vm._v("\n                                                                        Frais\n                                                                        professionnels\n                                                                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "th cln-checkbox"
  }, [_c('div', {
    staticClass: "inp-checkbox d-flex",
    attrs: {
      "data-testid": "avantages-en-nature-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.AvantageEnNature),
      expression: "salarieCourant.AvantageEnNature"
    }],
    attrs: {
      "type": "checkbox",
      "id": "AvantageEnNature",
      "disabled": !_vm.canModify
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.AvantageEnNature) ? _vm._i(_vm.salarieCourant.AvantageEnNature, null) > -1 : (_vm.salarieCourant.AvantageEnNature)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.AvantageEnNature,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "AvantageEnNature", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "AvantageEnNature", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "AvantageEnNature", $$c)
        }
      }, _vm.modifyForRubriques]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "AvantageEnNature"
    }
  }, [_vm._v("\n                                                                        Avantages\n                                                                        en nature\n                                                                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "th cln-checkbox"
  }, [_c('div', {
    staticClass: "inp-checkbox d-flex",
    attrs: {
      "data-testid": "congés-10ème-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CongesDixieme),
      expression: "salarieCourant.CongesDixieme"
    }],
    attrs: {
      "type": "checkbox",
      "id": "CongesDixieme",
      "disabled": !_vm.canModify
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.CongesDixieme) ? _vm._i(_vm.salarieCourant.CongesDixieme, null) > -1 : (_vm.salarieCourant.CongesDixieme)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.CongesDixieme,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "CongesDixieme", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "CongesDixieme", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "CongesDixieme", $$c)
        }
      }, _vm.modifyForRubriques]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "CongesDixieme"
    }
  }, [_vm._v("\n                                                                        Congés\n                                                                        10ème\n                                                                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "th cln-checkbox"
  }, [_c('div', {
    staticClass: "inp-checkbox d-flex",
    attrs: {
      "data-testid": "exonération-csg-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.ExonerationCsg),
      expression: "salarieCourant.ExonerationCsg"
    }],
    attrs: {
      "type": "checkbox",
      "id": "ExonerationCsg",
      "disabled": !_vm.canModify
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.ExonerationCsg) ? _vm._i(_vm.salarieCourant.ExonerationCsg, null) > -1 : (_vm.salarieCourant.ExonerationCsg)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.ExonerationCsg,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "ExonerationCsg", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "ExonerationCsg", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "ExonerationCsg", $$c)
        }
      }, _vm.modifyForRubriques]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "pl-2",
    attrs: {
      "for": "ExonerationCsg"
    }
  }, [_vm._v("\n                                                                        Exonération\n                                                                        CSG\n                                                                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "th cln-checkbox"
  }, [_c('div', {
    staticClass: "inp-checkbox d-flex",
    attrs: {
      "data-testid": "CSG-CRDS-apprentis-field"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CsgCrdsApprenti),
      expression: "salarieCourant.CsgCrdsApprenti"
    }],
    attrs: {
      "type": "checkbox",
      "id": "CsgCrdsApprenti",
      "disabled": _vm.isCsgApprentiActive()
    },
    domProps: {
      "checked": Array.isArray(_vm.salarieCourant.CsgCrdsApprenti) ? _vm._i(_vm.salarieCourant.CsgCrdsApprenti, null) > -1 : (_vm.salarieCourant.CsgCrdsApprenti)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.salarieCourant.CsgCrdsApprenti,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.salarieCourant, "CsgCrdsApprenti", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.salarieCourant, "CsgCrdsApprenti", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.salarieCourant, "CsgCrdsApprenti", $$c)
        }
      }, _vm.modifyForRubriques]
    }
  }), _vm._v(" "), _c('label', {
    class: ['pl-2', _vm.isCsgApprentiActive() ? 'tw-opacity-50' : ''],
    attrs: {
      "for": "CsgCrdsApprenti",
      "title": _vm.salarieCourant.ExonerationCsg == true ? 'CSG-CRDS Apprentis' : 'La case Exonération CSG doit être cochée pour modifier celle-ci'
    }
  }, [_vm._v("\n                                                                        CSG-CRDS Apprentis\n                                                                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-9 tw-mt-2"
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeTempsPartielCotisantTempsPlein),
      expression: "salarieCourant.CodeTempsPartielCotisantTempsPlein"
    }],
    staticClass: "input",
    attrs: {
      "disabled": !_vm.canModify
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeTempsPartielCotisantTempsPlein", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modify]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.tempsPartielCotisantTempsPleins), function(tempsPartielCotisantTempsPlein) {
    return _c('option', {
      domProps: {
        "value": tempsPartielCotisantTempsPlein.Code
      }
    }, [_vm._v("\n                                                                        " + _vm._s(tempsPartielCotisantTempsPlein.Libelle) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Salariés à temps partiel cotisant à temps plein")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row area"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [(_vm.ifModeCongeActive) ? _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "inp-input input-responsable icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.IdResponsableHierarchique),
      expression: "salarieCourant.IdResponsableHierarchique"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": " "
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "IdResponsableHierarchique", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modifyResponsableHierarchique]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeResponsablesHierarchiquesFiltres), function(responsableHierarchique) {
    return _c('option', {
      domProps: {
        "value": responsableHierarchique.IdSalarie
      }
    }, [_vm._v("\n                                                                        " + _vm._s(responsableHierarchique.Nom) + " " + _vm._s(responsableHierarchique.Prenom) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Responsable hierarchique")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "inp-input"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "type": "number",
      "placeholder": " ",
      "min": "0",
      "max": "100",
      "step": "1",
      "disabled": !_vm.canModify
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Étage")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.ifModeCongeActive) ? _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.IdAssistantGestion),
      expression: "salarieCourant.IdAssistantGestion"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": " "
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "IdAssistantGestion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modifyAssistantDeGestion]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeResponsablesHierarchiquesFiltres), function(responsableHierarchique) {
    return _c('option', {
      domProps: {
        "value": responsableHierarchique.IdSalarie
      }
    }, [_vm._v("\n                                                                        " + _vm._s(responsableHierarchique.Nom) + " " + _vm._s(responsableHierarchique.Prenom) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Assistant de gestion")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "inp-input icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salarieCourant.CodeService),
      expression: "salarieCourant.CodeService"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": " "
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salarieCourant, "CodeService", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modify]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.listeServices), function(item) {
    return _c('option', {
      domProps: {
        "value": item.Code
      }
    }, [_vm._v("\n                                                                        " + _vm._s(item.Code + '/' + item.Libelle) + "\n                                                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Service")]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])])])])])])]), _vm._v(" "), (_vm.contratsHistorique.length) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row area mb-3"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "height": "277px"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "body-table"
  }, [_c('table', {
    staticClass: "generic-table"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_vm._m(6), _vm._v(" "), _vm._l((_vm.contratsHistorique), function(contrat) {
    return _c('tr', [_c('th', {
      staticClass: "cln-numero",
      attrs: {
        "title": contrat.NumeroContrat
      }
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center"
    }, [_vm._v(_vm._s(contrat.NumeroContrat))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-societe",
      attrs: {
        "title": contrat.CodeSociete
      }
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center"
    }, [_vm._v(_vm._s(contrat.CodeSociete))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-poste",
      attrs: {
        "title": contrat.LibelleEmploi
      }
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-start"
    }, [_vm._v(_vm._s(contrat.LibelleEmploi))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-entree",
      attrs: {
        "title": _vm._f("moment")(contrat.DateEntree, 'DD/MM/YYYY')
      }
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(contrat.DateEntree, "DD/MM/YYYY")))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-debut",
      attrs: {
        "title": _vm._f("moment")(contrat.DateDebut, 'DD/MM/YYYY')
      }
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(contrat.DateDebut, "DD/MM/YYYY")))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-transfert",
      attrs: {
        "title": _vm._f("moment")(contrat.DateDebutTransfert, 'DD/MM/YYYY')
      }
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(contrat.DateDebutTransfert, "DD/MM/YYYY")))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-fin",
      attrs: {
        "title": _vm._f("moment")(contrat.DateFinContrat, 'DD/MM/YYYY')
      }
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(contrat.DateFinContrat, "DD/MM/YYYY")))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-type",
      attrs: {
        "title": contrat.CodeTypeContrat
      }
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center"
    }, [_vm._v(_vm._s(contrat.CodeTypeContrat))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-qualification",
      attrs: {
        "title": contrat.CodeQualification
      }
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center"
    }, [_vm._v(_vm._s(contrat.CodeQualification))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-actions"
    }, [(contrat.NumeroContrat != _vm.salarieCourant.NumeroContrat) ? _c('button', {
      staticClass: "blue inp-button-outline",
      attrs: {
        "type": "button",
        "title": "Charger le contrat"
      },
      on: {
        "click": function($event) {
          _vm.viewDetails(contrat)
        }
      }
    }, [_c('span', {
      staticClass: "far fa-eye"
    })]) : _vm._e(), _vm._v(" "), (contrat.CanDelete) ? _c('button', {
      staticClass: "red inp-button-outline",
      attrs: {
        "type": "button",
        "title": "Supprimer le contrat",
        "data-testid": "supprimer-le-contrat-field"
      },
      on: {
        "click": function($event) {
          _vm.deleteContrat(contrat.IdContrat)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-trash"
    })]) : _vm._e()])])
  })], 2)])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "m-0 col-lg-3 col-md-12 right"
  }, [_c('liste-rubriques-salarie-component', {
    attrs: {
      "salarieCourant": _vm.salarieCourant
    },
    on: {
      "isModified": _vm.modify
    }
  })], 1), _vm._v(" "), (_vm.errorMessage.length) ? _c('p', [_c('strong', [_vm._v("La saisie du salarié contient des erreurs :")]), _vm._v(" "), _c('ul', _vm._l((_vm.errorMessage), function(error) {
    return _c('li', [_vm._v(_vm._s(error))])
  }))]) : _vm._e()])])])]), _vm._v(" "), (_vm.isModified) ? _c('div', {
    staticClass: "validation-area mt-3"
  }, [_c('div', {
    staticClass: "area-action"
  }, [_vm._m(7), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.annuler()
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Annuler")])])])]) : _vm._e()]), _vm._v(" "), (_vm.modalRegimeDecisionVisible) ? _c('modal-regime-decision-entree-salarie', {
    attrs: {
      "liste-maladie-retraites": _vm.listeMaladieRetraitesFiltree
    },
    on: {
      "apply": _vm.onRegimeDecisionApply,
      "closed": function($event) {
        _vm.modalRegimeDecisionVisible = false
      }
    },
    model: {
      value: (_vm.isManualChoice),
      callback: function($$v) {
        _vm.isManualChoice = $$v
      },
      expression: "isManualChoice"
    }
  }) : _vm._e()], 1) : _c('loader', {
    staticClass: "loader"
  })
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("DÉFINITIONS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("ACCORDS PARTICULIERS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("AFFECTATION")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infobulle"
  }, [_c('span', [_vm._v("Le responsable hiérarchique n'est pas la personne qui validera les absences. Le paramétrage des valideurs d'absences, se fait au niveau de l'onglet Absences")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head mb-1"
  }, [_c('div', {
    staticClass: "title-head"
  }, [_vm._v("HISTORIQUE DE CARRIÈRE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "tr"
  }, [_c('th', {
    staticClass: "cln-numero",
    attrs: {
      "title": "N° Contrat"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("N°")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-societe",
    attrs: {
      "title": "Société"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("SOCIÉTÉ")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-poste",
    attrs: {
      "title": "Poste"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("POSTE")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-entree",
    attrs: {
      "title": "Entrée"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("ENTRÉE")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-debut",
    attrs: {
      "title": "Début"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("DÉBUT")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-transfert",
    attrs: {
      "title": "Transfert"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("TRANSFERT")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-fin",
    attrs: {
      "title": "FIN"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("FIN")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-type",
    attrs: {
      "title": "Type contrat"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("TYPE")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-qualification",
    attrs: {
      "title": "Qualification"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("QUALIFICATION")])]), _vm._v(" "), _c('th', {
    staticClass: "cln-actions",
    attrs: {
      "title": "Voir"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Action")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "line"
  }, [_c('th', {
    staticClass: "section cln-numero"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-societe"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-poste"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-entree"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-debut"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-transfert"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-fin"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-type"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-qualification"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-actions"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "inp-button-modal valid",
    attrs: {
      "type": "submit",
      "data-testid": "contratSalarie-valider-button-field"
    }
  }, [_c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Valider")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc8a3fe6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ficheSalarie/contratSalarie/contratSalarie.vue.html
// module id = WNv5
// module chunks = 2